// import { BELT_COLORS } from './DrillConstants';
import { BELT_LEVELS, BELT_COLORS } from './DrillConstants';

export const sidebarStyles = {
    calibrateBtn: (isActive) => ({
        background: isActive ? '#1a3a1a' : '#181818',
        color: isActive ? '#2ecc71' : '#888',
        border: `1px solid ${isActive ? '#2ecc71' : '#333'}`,
        marginBottom: '12px',
        fontWeight: 'bold',
    }),
    calibrateInfo: {
        fontSize: '10px',
        color: '#555',
        marginTop: '2px'
    },
    latencyBox: (hasLatency) => ({
        background: '#181818',
        border: `1px solid ${hasLatency ? '#2ecc7133' : '#2a2a2a'}`,
        borderRadius: '6px',
        padding: '8px 10px',
        marginBottom: '12px',
        fontSize: '11px',
    }),
    latencyValue: (hasLatency) => ({
        fontFamily: 'monospace',
        color: hasLatency ? '#2ecc71' : '#444',
        fontWeight: 'bold'
    }),
    latencyLink: {
        marginTop: '4px',
        fontSize: '10px',
        color: '#444'
    },
    latencyLinkTag: {
        color: '#3498db',
        textDecoration: 'none'
    },
    sectionLabel: {
        color: '#aaa',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '1px',
        marginBottom: '6px'
    },
    drillButton: (isSelected, isFullTest) => ({
        background: isSelected ? (isFullTest ? '#1a3a1a' : '#1a3a5c') : '#222',
        color: isSelected ? (isFullTest ? '#2ecc71' : '#5dade2') : '#ccc',
        border: isSelected ? `1px solid ${isFullTest ? '#2ecc71' : '#5dade2'}` : '1px solid #333',
        fontWeight: isSelected ? 'bold' : 'normal',
    }),
    drillName: {
        fontSize: '12px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    drillSubtitle: {
        fontSize: '10px',
        color: '#777',
        marginTop: '2px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    accordionHeader: (isExpanded) => ({
        background: '#2c1e16',
        color: '#e67e22',
        border: '1px solid #d35400',
        borderRadius: isExpanded ? '6px 6px 0 0' : '6px',
        padding: '8px 10px',
        marginBottom: isExpanded ? 0 : '5px',
        borderBottom: isExpanded ? 'none' : '1px solid #d35400',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%'
    }),
    accordionHeaderText: {
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '1px',
        fontWeight: 'bold'
    },
    accordionArrow: (isExpanded) => ({
        transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
        transition: 'transform 0.3s ease',
        display: 'inline-block',
        fontSize: '10px'
    }),
    accordionContent: (isExpanded) => ({
        maxHeight: isExpanded ? '1200px' : '0',
        opacity: isExpanded ? 1 : 0,
        pointerEvents: isExpanded ? 'auto' : 'none',
        border: isExpanded ? '1px solid #d35400' : 'none',
        borderTop: 'none',
        borderRadius: '0 0 6px 6px',
        padding: isExpanded ? '10px 8px' : '0 8px',
        background: 'rgba(44, 30, 22, 0.2)'
    }),
    resultsContainer: {
        borderTop: '1px solid #333',
        paddingTop: '12px'
    },
    resultRow: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '4px',
        fontSize: '12px'
    },
    resultValue: (belt) => ({
        fontFamily: 'monospace',
        color: belt === 'miss' ? '#e74c3c' : BELT_COLORS[belt]
    }),
    footerButtons: {
        display: 'flex',
        gap: '10px',
        marginTop: '20px'
    },
    footerBtn: {
        flex: 1,
        background: '#222',
        color: '#888',
        border: '1px solid #333',
        borderRadius: '6px',
        padding: '10px',
        cursor: 'pointer',
        fontSize: '12px',
        fontWeight: 'bold',
        letterSpacing: '0.5px'
    }
};

export const overlayStyles = {
    overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0,0,0,0.75)',
        zIndex: 10,
        backdropFilter: 'blur(2px)',
    },
    overlayBox: {
        background: '#1a1a2e',
        border: '1px solid #2c3e50',
        borderRadius: '12px',
        padding: '24px',
        maxWidth: '500px',
        width: '90%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.6)',
    },
    startBtn: (isFullTest) => ({
        background: isFullTest ? '#1a3a1a' : '#1a3a5c',
        color: isFullTest ? '#2ecc71' : '#5dade2',
        border: `1px solid ${isFullTest ? '#2ecc71' : '#5dade2'}`,
        borderRadius: '6px',
        padding: '10px 24px',
        fontSize: '14px',
        fontWeight: 'bold',
        cursor: 'pointer',
        letterSpacing: '1px',
    }),
    fullTestGrid: {
        width: '100%',
        marginBottom: '16px',
        overflowX: 'auto'
    },
    fullTestGridInner: {
        display: 'grid',
        gridTemplateColumns: `minmax(100px, 1fr) repeat(${BELT_LEVELS.length}, 45px)`,
        gap: '8px 4px',
        fontSize: '10px',
        marginBottom: '6px'
    },
    beltHeader: (belt) => ({
        color: BELT_COLORS[belt],
        fontWeight: 'bold',
        textAlign: 'center',
        textTransform: 'uppercase',
        borderBottom: '1px solid #333',
        paddingBottom: '4px',
        fontSize: '9px'
    }),
    singleDrillGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '8px',
        marginBottom: '16px'
    },
    standbyLabel: {
        position: 'absolute',
        bottom: '20%',
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'rgba(255,255,255,0.5)',
        fontSize: '14px',
        pointerEvents: 'none',
        zIndex: 110
    },
    resultTime: (passed, belt) => ({
        fontSize: '42px',
        fontWeight: 'bold',
        fontFamily: 'monospace',
        color: passed ? BELT_COLORS[belt] : '#e74c3c',
        marginBottom: '4px'
    }),
    resultStats: {
        display: 'flex',
        gap: '12px',
        marginBottom: '12px',
        fontSize: '11px',
        color: '#888'
    },
    progressBarContainer: {
        marginBottom: '16px',
        width: '100%'
    },
    progressBarRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '4px'
    },
    progressBarLabel: (achieved, belt) => ({
        color: achieved ? BELT_COLORS[belt] : '#444',
        width: '52px',
        fontSize: '11px',
        textTransform: 'capitalize',
        fontWeight: 'bold'
    }),
    progressBarBackground: {
        height: '6px',
        flex: 1,
        background: '#222',
        borderRadius: '3px',
        overflow: 'hidden'
    },
    progressBarFill: (achieved, belt, percent) => ({
        height: '100%',
        width: `${percent}%`,
        background: achieved ? BELT_COLORS[belt] : '#444',
        borderRadius: '3px'
    }),
    infoBtn: {
        padding: '8px 10px',
        background: '#1a2a3a',
        color: '#5dade2',
        border: '1px solid #2c5282',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '15px',
        fontWeight: 'bold',
        lineHeight: 1,
        flexShrink: 0,
    }
};

export const modalStyles = {
    overlay: {
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.75)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: '20px',
    },
    content: {
        background: '#141c28',
        border: '1px solid #2c5282',
        borderRadius: '12px',
        padding: '32px',
        maxWidth: '560px',
        width: '100%',
        color: '#e0e6f0',
        fontFamily: 'Inter, sans-serif',
        maxHeight: '85vh',
        overflowY: 'auto',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px'
    },
    title: {
        margin: 0,
        fontSize: '20px',
        color: '#5dade2',
        letterSpacing: '0.5px'
    },
    closeBtn: {
        background: 'none',
        border: 'none',
        color: '#888',
        fontSize: '22px',
        cursor: 'pointer',
        lineHeight: 1
    },
    section: {
        marginBottom: '20px'
    },
    sectionTitle: {
        color: '#f39c12',
        fontSize: '13px',
        textTransform: 'uppercase',
        letterSpacing: '1px',
        marginBottom: '8px'
    },
    text: {
        margin: 0,
        lineHeight: 1.7,
        fontSize: '14px',
        color: '#b8c5d6'
    },
    list: {
        marginTop: '10px',
        paddingLeft: '20px',
        lineHeight: 2,
        fontSize: '13px',
        color: '#b8c5d6'
    }
};

export const badgeStyles = {
    container: (belt) => ({
        position: 'absolute',
        bottom: '16px',
        left: '16px',
        background: 'rgba(0,0,0,0.65)',
        border: `1px solid ${BELT_COLORS[belt]}66`,
        borderRadius: '8px',
        padding: '6px 12px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        backdropFilter: 'blur(4px)',
        pointerEvents: 'none',
        zIndex: 5,
    }),
    dot: (belt) => ({
        width: '10px',
        height: '10px',
        borderRadius: '50%',
        background: BELT_COLORS[belt],
        boxShadow: `0 0 6px ${BELT_COLORS[belt]}`,
    }),
    text: (belt) => ({
        color: BELT_COLORS[belt],
        fontSize: '12px',
        fontWeight: 'bold',
        textTransform: 'capitalize',
        letterSpacing: '0.5px'
    })
};
